<!-- Outside both shell branches on purpose: it lived in <app-topbar />, which
     the horizontal shell never renders, so every toast was dropped there. -->
<app-global-toast />

@if (isHeadlessRoute()) {
  <router-outlet />
} @else if (session.enableHorizontalNav() && !isAuthRoute()) {
  <!-- ═══ Menu-axis Phase 2 — new horizontal shell ═══ -->
  <app-topbar-v3 />
  <app-nav-v3 />
  <div class="page page--horizontal">
    @if (showRail()) {
      <div class="rail-col" [class.rail-empty]="!railHost.hasRail()"
           [class.rail-collapsed]="railLayout.collapsed()">
        <app-rail-host #railHost />
        <app-selection-tray />
      </div>
    }
    <div class="workspace-gutter"></div>
    <div class="ct">
      <router-outlet />
    </div>
  </div>
} @else {
  <!-- ═══ Legacy shell (default + auth routes) ═══ -->
  @if (!isAuthRoute()) {
    <app-topbar />
    <app-case-bar />
  }
  <div class="page">
    @if (!isAdmin() && !isAuthRoute()) { <app-sidebar /> }
    <div class="ct" [class.admin-mode]="isAdmin()" [class.auth-mode]="isAuthRoute()">
      <router-outlet />
    </div>
  </div>
}

@if (!isAuthRoute() && !isHeadlessRoute()) {
  <footer class="footer">
    <div>Copyright&copy; 2026 Beacon Annuity Solutions, LLC All Rights Reserved
       <!-- <a href="#">Terms and Conditions</a> | <a href="#">Privacy Policy</a> -->
    </div>
    <div class="footer-right"><img src="data:image/gif;base64,R0lGODlhdgAXANUAAJ6ensnJycLCwkNDQ+7u7qysrDMzM9XV1dnZ2QgICJmZmaqqqru7u4GBgcbGxqGhoWtra/r6+nd3dyIiIisrK93d3ZWVlXp6erS0tPj4+MzMzGZmZvb29r29vaampoeHh/T09GFhYaSkpE1NTeDg4Ojo6OTk5Dw8PH5+fllZWUlJSVFRUfz8/BsbG5CQkKioqI2Njbi4uBEREebm5rKyslVVVdDQ0M7OzvLy8t7e3rCwsOvr63BwcF5eXgAAAP///yH5BAAAAAAALAAAAAB2ABcAAAb/wN9PwygShMikcslkMirIZ3NKrVqvU59Wq8F6kRqfQhgef8/odEX8I/gkbWmlS2AIpYzur8Ko7/tgGgo+UD+DREdSP4BIHiEQGw0NEDwXFgEsSRERaZ0/Cz5dH2KDWh8SPj81qYdbGz8bW6WEqlupQrFbPz41hj5HSClaLSO2WiM7PyU2FSCeaahbNW6vsQyEWmsSqASxu6HUbhJhC263358+16k+H0oDPi0KE8Y+CQ0FMSWZz2haRVCu2UF1rcaqVeZ0+Xi1TosCVELeIJEISsOqQUoiGEjQoYetBAMawBgQoJ+nhUnWfHBTIww2NggV5PGxYE+7CitHaRhVc4gP/wPooplBQsCAgAdaQLrAAONEAnUm1bBJMorXEV7o2mwRRMsXyoRdB+XqAuoc0RsdEhiwcMCBBHpJD0SdS/cLwSYeugRI8dSWirqAAzPRAqdJhgcU6vmggECw48dUIgj4sGJC3wQfMgip4GGBZw8MMkWg4cGDAyQZHIgAAEAAvwoFWDPg0KbAC9B3HsiFTNfGBw80CjRYkdiAngbGVgjBsOWvMni2APz40FfLX+bDMuBo4UME77kkCKBIKqOFjKcTjqxYDClFASHwZPzMFMKHjBoqCMfQciKEAS0OuGCPPSTYYM9u33nS1gIrgFBAdba8R89QQujgwwTjtRBBCfJZ8P9DBikY4IgPyv0QgBYC1DeCfAKAMgFtCXqiwAA5JDABAgzIZwwAJqBHwQQpwOfDBdfIkAFzCRQiBAcTClFAPCYk5gI9D4xSYoydxEJDMQk8cENitnTAnAwnnGAACunIYIID9pQwngGcRAACCzY8ddoPF/igAgIJJBDACT7wIAyaWKahkQ8pIKdFDw4AqsUEEeQZJBIc/JfAj/Y4sMoIQlyQwAoW2GPCDyD818B+LXAgzAD0vFcoGnza10B1BsRQDBuAnikBDwGAcukEcOmQnwwh9PDUBaWowAOgCfjmA6d5PpVAY6+eAcAWI8ClhQwNqDCGCTpuYQE8PAgxg3wehGpeywklRGmLDB7Cg+YsFGhW7Rc3ACDCA/k8IMK/HgQQgwcREFDAwQfrgMDBJQgRAQYeNKbBaq3ZSwAGrGEwww8Pe5DDDyYc/IIA9wbWK4wlpxxVCRo4o/LLz2SQTLVBAAA7" alt="Powered by Beacon"></div>
  </footer>
  @defer (on idle; when profile.isOpen()) {
    <app-profile-flyout />
  }
  <app-broker-profile-flyout />
}
